"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopHeroLinkToJSON = exports.ShopHeroLinkFromJSONTyped = exports.ShopHeroLinkFromJSON = exports.instanceOfShopHeroLink = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ShopHeroLink interface.
 */
function instanceOfShopHeroLink(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfShopHeroLink = instanceOfShopHeroLink;
function ShopHeroLinkFromJSON(json) {
    return ShopHeroLinkFromJSONTyped(json, false);
}
exports.ShopHeroLinkFromJSON = ShopHeroLinkFromJSON;
function ShopHeroLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.ShopHeroLinkFromJSONTyped = ShopHeroLinkFromJSONTyped;
function ShopHeroLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'text': value.text,
        'url': value.url,
    };
}
exports.ShopHeroLinkToJSON = ShopHeroLinkToJSON;
